import React, { useRef, useEffect, useState } from 'react';
import "../style/Mission.css";

const Mission = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setIsVisible(entry.isIntersecting),
            { threshold: 0.3 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className={`mission ${isVisible ? 'animate' : ''}`} ref={sectionRef}>
            <h1>MISSION</h1>

            <div className='mission_para'>
                <div className='mission_list'>
                    <ul>
                        <li><strong>Innovation at the Core:</strong> Continuously redefining packaging boundaries with forward-thinking solutions.</li>
                        <li><strong>Eco-Excellence:</strong> Prioritizing sustainability to help clients achieve green goals.</li>
                        <li><strong>Customer Partnership:</strong> Long-term relationships focused on mutual growth.</li>
                        <li><strong>Reliability:</strong> Timely delivery, precise execution, and flawless quality every time.</li>
                    </ul>
                </div>

                <div className='mission_img'>
                    <div className='img'></div>
                </div>
            </div>
        </div>
    );
};

export default Mission;
